/**
 * @jsx jsx
 * @jsxFrag
 */
import { jsx } from '@compiled/react';
import { defineMessages, useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { LazyAnimatedCreateWithRovoIcon } from '@atlassian/conversation-assistant-ui-components/ui/LazyAnimatedCreateWithRovoIcon';

const messages = defineMessages({
	loading: {
		id: 'conversation-assistant.recommended-spaces-panel.RecommendedSpacesPanelSkeleton.loading',
		defaultMessage: 'Loading recommendations\u2026',
		description: 'Text shown while recommended spaces are being loaded from the server',
	},
});

const styles = cssMap({
	panel: {
		inlineSize: '100%',
		blockSize: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		overflow: 'hidden',
		paddingBlockStart: token('space.300'),
		paddingBlockEnd: token('space.300'),
		paddingInlineStart: token('space.300'),
		paddingInlineEnd: token('space.300'),
	},
});

export const RecommendedSpacesPanelSkeleton = ({
	testId = 'recommended-spaces-panel-skeleton',
}: {
	testId?: string;
}): JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Box
			xcss={styles.panel}
			testId={testId}
			role="status"
			aria-label={formatMessage(messages.loading)}
		>
			<Box aria-hidden="true">
				<LazyAnimatedCreateWithRovoIcon testId={`${testId}-loader`} width="148px" height="88px" />
			</Box>
		</Box>
	);
};
